import { render, staticRenderFns } from "./DbpyL_List.vue?vue&type=template&id=49fffaa4"
import script from "./DbpyL_List.vue?vue&type=script&lang=js"
export * from "./DbpyL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports